export const BOUNDARY_ITEMS_FETCH_REQUEST = 'BOUNDARY_ITEMS_FETCH_REQUEST';
export const BOUNDARY_ITEMS_FETCH_SUCCESS = 'BOUNDARY_ITEMS_FETCH_SUCCESS';
export const BOUNDARY_ITEMS_FETCH_ERROR = 'BOUNDARY_ITEMS_FETCH_ERROR';
export const BOUNDARY_ITEMS_FETCH_CANCEL = 'BOUNDARY_ITEMS_FETCH_CANCEL';
export const BOUNDARY_ITEMS_UPDATE_ITEM_NAME_SUCCESS = 'BOUNDARY_ITEMS_UPDATE_ITEM_NAME_SUCCESS';
export const BOUNDARY_ITEMS_REMOVE_ITEM_SUCCESS = 'BOUNDARY_ITEMS_REMOVE_ITEM_SUCCESS';
export const BOUNDARY_ITEMS_FETCHED_DATA = 'BOUNDARY_ITEMS_FETCHED_DATA';
export const BOUNDARY_ITEMS_UPDATE_ITEMS = 'BOUNDARY_ITEMS_UPDATE_ITEMS';
export const BOUNDARY_ITEMS_RESET = 'BOUNDARY_ITEMS_RESET';
